import { FormConfig } from '../../../models/form-config';
import { FieldType } from '../../../models/field-type';
import { Offer } from '../../../../core/models/offer/offer.model';
import { TranslateService } from '@ngx-translate/core';
import { OfferPremium } from '../../../../core/models/offer/offer-premium.model';
import { OfferPremiumInstallment } from '../../../../core/models/offer/offer-premium-installment';
import { mapFloatToStringWithComma } from '../../../utils/string-utils';
import { Validator } from '../../../models/validator.enum';
import {InstallmentStateService} from '../../../../core/services/impl/section-services/installment/installment-state.service';
import {OfferPremiumInstallmentCode} from '../../../../core/consts/offer-premium-installment-code.enum';
import {isNext} from '../../../../core/utils/utils';

export class InstallmentSectionConfig {

  readonly PREMIUM_ID = 'premiumId';
  offer: Offer;
  isNext = isNext();
  private readonly CURRENCY = 'OFFER_SECTION.SHARED.currencyShortcut';

  constructor(private stateService: InstallmentStateService,
              private ts: TranslateService) {
    this.offer = this.stateService.selectedOffer;
  }

  createConfig(): FormConfig {

    return {
      formKey: 'INSTALLMENT_SECTION',
      fieldsConfig: [
        {
          fieldKey: this.PREMIUM_ID,
          type: this.isNext ? FieldType.RadioCheckboxTile : FieldType.Radio,
          validators: [Validator.REQUIRED],
          radioConfig: [
            ...this.buildRadioConfig(this.offer)
          ],
          radioCheckboxTileConfig: this.isNext ? {
            contentDataValuePropertyName: 'premiumId',
            getAnalyticsFieldValue: itemData => `${this.ts.instant(itemData.label)} ${mapFloatToStringWithComma(itemData.premiumAmount)} ${this.ts.instant(this.CURRENCY)}`
          } : undefined,
          analyticsConfig: {
            customFieldName: 'INSTALLMENT_SECTION.title'
          }
        },

      ]
    }
  }

  private buildRadioConfig(offer: Offer) {
    return this.stateService.getPremiumsSortedByAmount(offer)
        .map(el => this.createSingleInstalment(el));
  }

  private createSingleInstalment(el: OfferPremium) {
    const value = mapFloatToStringWithComma(this.findFirstInstallment(el.instalments).value);
    const instalmentAmount = mapFloatToStringWithComma(el.amount.amount);
    let mainPrice, tailsPrice;
    if (instalmentAmount.includes(',')) {
      mainPrice = instalmentAmount.split(',')[0].replace(' ', '&nbsp;');
      tailsPrice = instalmentAmount.split(',')[1];
    }
    return {
      value: el.id,
      label: `INSTALLMENT_SECTION.INSTALLMENTS.${el.instalments.length}`,
      boldedLabel: mapFloatToStringWithComma(el.amount.amount),
      mainPrice: mainPrice,
      tailsPrice: tailsPrice,
      message: this.ts.get('INSTALLMENT_SECTION.INSTALLMENTS.firstInstallmentWithAmount', { value }),
      currency: this.CURRENCY
    }
  }

  private findFirstInstallment(instalments: OfferPremiumInstallment[]): OfferPremiumInstallment {
    return <OfferPremiumInstallment>instalments.filter(({ code }) => code === OfferPremiumInstallmentCode.ONE_INSTALMENT)[0];
  }

}


